import { useState } from "react";
import { toast } from "sonner";
import { Loader2, ArrowUpRight } from "lucide-react";
import { api } from "@/lib/api";
import { useNavigate } from "react-router-dom";

export default function ContactForm() {
  const navigate = useNavigate();
  const [data, setData] = useState({
    first_name: "",
    last_name: "",
    company: "",
    email: "",
    phone: "",
    message: "",
  });
  const [submitting, setSubmitting] = useState(false);
  const set = (k, v) => setData((p) => ({ ...p, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.post("/contact", { ...data, source_page: "kontakt" });
      navigate("/danke");
    } catch (err) {
      const msg = err?.response?.data?.detail || "Anfrage fehlgeschlagen";
      toast.error(typeof msg === "string" ? msg : "Anfrage fehlgeschlagen");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form onSubmit={submit} className="surface p-6 md:p-8" data-testid="contact-form">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        <div>
          <label className="field-label">Name *</label>
          <input
            required
            value={data.first_name}
            onChange={(e) => set("first_name", e.target.value)}
            className="field"
            data-testid="contact-input-name"
          />
        </div>
        <div>
          <label className="field-label">Unternehmen</label>
          <input
            value={data.company}
            onChange={(e) => set("company", e.target.value)}
            className="field"
            data-testid="contact-input-company"
          />
        </div>
        <div>
          <label className="field-label">E-Mail *</label>
          <input
            required
            type="email"
            value={data.email}
            onChange={(e) => set("email", e.target.value)}
            className="field"
            data-testid="contact-input-email"
          />
        </div>
        <div>
          <label className="field-label">Telefon</label>
          <input
            value={data.phone}
            onChange={(e) => set("phone", e.target.value)}
            className="field"
            data-testid="contact-input-phone"
          />
        </div>
      </div>
      <div className="mt-5">
        <label className="field-label">Nachricht *</label>
        <textarea
          required
          value={data.message}
          onChange={(e) => set("message", e.target.value)}
          className="field"
          data-testid="contact-input-message"
        />
      </div>
      <button
        type="submit"
        disabled={submitting}
        className="btn-primary mt-6 disabled:opacity-50"
        data-testid="contact-submit"
      >
        {submitting ? (
          <>
            <Loader2 size={16} strokeWidth={1.5} className="animate-spin" /> Wird gesendet…
          </>
        ) : (
          <>
            Nachricht senden <ArrowUpRight size={16} strokeWidth={1.5} />
          </>
        )}
      </button>
    </form>
  );
}
